import { useWorksheetContext } from '../../providers/WorksheetProvider';
import { useState } from 'react';
import AddonsSidebar from './addons/AddonsSidebar';
import Entries from './entries/Entries';
import ContentTabs from './generic-worksheet/ContentTabs';
import WorksheetHistory from '../worksheet/history/WorksheetHistory';
import FilesSection from '../files/FilesSection';
import ContentContainer from './ContentContainer';
import Checklist from './checklist/Checklist';
import AccountFigures from './reconciliation-worksheet/AccountFigures';
import NavBreadcrumbs from '../../components/nav-breadcrumbs/NavBreadcrumbs';
import WorksheetJournals from '../worksheet/journals/WorksheetJournals';
import { useWorkpaperContext } from '../../providers/WorkpaperProvider';
import { useFirmContext } from '../../providers/FirmProvider';
import { GenericWorksheet, WorksheetWithAccount } from '../../types/worksheet';
import TopSection from './top-section/TopSection';
import ScrollHeader from './top-section/scroll-header/ScrollHeader';
import CalculationsContainer from './calculations/CalculationsContainer';
import XeroErrorAlert from '../../components/XeroErrorAlert';

function DefaultGenericWorksheet(): JSX.Element {
    const { worksheet, priorWorksheet } = useWorksheetContext<GenericWorksheet>();
    const [content, setContent] = useState('entries');
    const [xeroAuthError, setXeroAuthError] = useState(false);
    const { id, readOnly, entity } = useWorkpaperContext();
    const { shortId } = useFirmContext();

    return (
        <div className="flex w-full h-full">
            <div className="w-full flex flex-col relative">
                <NavBreadcrumbs
                    paths={[
                        {
                            label: worksheet.account ? 'Trial Balance' : 'Other Schedules',
                            to: `/${shortId}/workpapers/${id}/${worksheet.account ? 'trial-balance' : 'other-schedules'}`,
                        },
                    ]}
                />

                {xeroAuthError && (
                    <div className="my-1">
                        <XeroErrorAlert
                            errorName="IntegrationError"
                            message="Authentication Unsuccessful"
                            entityId={entity.id}
                            entityName={entity.name}
                            promptConnect
                        />
                    </div>
                )}
                <TopSection worksheet={worksheet} onXeroAuthError={(): void => setXeroAuthError(true)} />
                {worksheet.account && (
                    <div className="my-4">
                        <AccountFigures account={worksheet.account} worksheet={worksheet as WorksheetWithAccount} />
                    </div>
                )}
                <ScrollHeader worksheet={worksheet} onXeroAuthError={(): void => setXeroAuthError(true)} />
                {!worksheet.account && <div className="mt-2"></div>}
                <ContentTabs worksheet={worksheet} onChange={setContent} />
                <ContentContainer>
                    {content === 'entries' && <Entries worksheet={worksheet} priorWorksheet={priorWorksheet} />}
                    {content === 'calculations' && <CalculationsContainer worksheet={worksheet} priorWorksheet={priorWorksheet} />}
                    {content === 'checklist' && <Checklist worksheet={worksheet} />}
                    {content === 'journals' && worksheet.account && worksheet.journals && (
                        <WorksheetJournals worksheet={worksheet as WorksheetWithAccount} onXeroError={console.log} />
                    )}
                    {content === 'files' && <FilesSection startingFolderId={worksheet.id} readOnly={readOnly} />}
                    {content === 'history' && <WorksheetHistory worksheet={worksheet} />}
                </ContentContainer>
            </div>
            <AddonsSidebar worksheet={worksheet} />
        </div>
    );
}

export default DefaultGenericWorksheet;
